module.exports = new __parcel__URL__("briefcase.d6e3da3b.svg").toString();